import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../firebase';
import Skeleton from 'react-loading-skeleton';

const ProtectedRoute = ({ children, redirectTo = '/login' }) => {
  const [user, loading] = useAuthState(auth);

  if (loading) {
    return (
      <div className="container mt-5 p-0">
        <Skeleton height={160} className="mb-4" borderRadius={12} />
        <Skeleton height={40} width="40%" className="mb-3" />
        <div className="row">
          {[1, 2, 3].map(i => (
            <div key={i} className="col-md-4 mb-4">
              <Skeleton height={200} borderRadius={12} />
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to={redirectTo} />;
  }

  return children;
};

export default ProtectedRoute;